const TournamentDetailsTypes = {
    GET_TOURNAMENT_DETAILS_START:'GET_TOURNAMENT_DETAILS_START',
    GET_TOURNAMENT_DETAILS_SUCCESS:'GET_TOURNAMENT_DETAILS_SUCCESS',
    GET_TOURNAMENT_DETAILS_FAILED:'GET_TOURNAMENT_DETAILS_FAILED',
    SET_TOURNAMENT_ACTIVE_TAB:'SET_TOURNAMENT_ACTIVE_TAB'

}

export default TournamentDetailsTypes